module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABBUlEQVRYR+2UQQrCMBBFZ3oR93Z6nYJ76VrwANYLuHHpThBFr+ENOvE00pGIQohtmqRCN+myTfMfL3+CMPGDE+dDAkgGkoFk4McAEZ0BYCYiS6XU4x8XVZ7nc0Q8AsCdmVfmnl0AGwCoEVG1bVuOhdDhWZZdRSQHgC0z104A/ZGI9KLNWAgzXER2Sqm1bbS3hGMhzHBEPDRNU3Udp3MKYiEs7RdmXvR1aXAMQyGs8Bszl64iDwJ8OuFVzNBwvbcXgE8xY8KDAFwQseHBAF0Q+p0x54Nn7j2GruIQ0bsT1prg8CgD39CiKCoRqRDxKSInZt7HXNveJYzZ3OefBJAMJAPJwOQGXpdQtiFIVzp7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select.png
// module id = sceL
// module chunks = 103